var Mustache = require('mustache');
import autosize from "autosize/dist/autosize";
import { Note } from "./CRUDs/entities/Note";
import Tagify from '@yaireo/tagify';

export default {
    init() {
        this.setHandlers();
      //  this.autoSave();
        this.openmenu();
        this.viewOpen();
        this.viewBack();
    },

    changeSize(id) {
        $this.copyTextToValue('#notepad #note-text', '#notepad id');
        $(id).removeClass('d-none');
        $('#notepad #note-text').addClass('d-none');
        $('#notepad .edit-text').addClass('d-none');
        $('#notepad .save-text').removeClass('d-none');
        $(id).focus();
        autosize.update(window.autosizeTa);
    },

    setHandlers() {
        let $this = this;

        if($(window).width() > 768) {
            $('#height-value').css('min-height', $(window).height() - 160 + 'px');
        }

        $('body').on('click', '#notepad #new_folder', function(e) {
            $('#folder_modal_title').text('New ');
            $('#folder_modal #folder_name').val('');
            $('#folder_modal .add').removeClass('d-none');
            $('#folder_modal .save').addClass('d-none');
            $('#folder_modal').modal('show');
        });

        $('body').on('click', '#notepad #new_note', function(e) {
            let category = $(this).data('category-name');
            $("#note_folder option:contains(" + category + ")").prop("selected", true);



            $('#note_modal #note_name').val('');
            $('#note_modal').modal('show');
        });

        $('body').on('click', '#folder_modal .add', function(e) {
            $.ajax({
                type: 'POST',
                url: '/notes/create-folder',
                data: ({
                    name: $('#folder_modal #folder_name').val()
                }),
                success: function (response) {
                    $this.getFolders();
                    location.reload();
                },
                error: function (response) {
                    console.log(response);
                },
            });
        });

        $('body').on('click', '#note_modal .add', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/notes/create-note',
                data: ({
                    name: $('#note_modal #note_name').val(),
                    folder_id: $('#note_modal #note_folder').val()
                }),
                success: function (response) {
                    let notes = response.notes;
                    $this.updateNotes(notes);
                    $this.getFolders();
                    $('#count_all_folders').text(response.notes.length);
                    $('#note_modal').modal('hide')
                    location.reload();
                },
                error: function (response) {
                    console.log(response);
                },
            });
        });

        $('body').on('click', '#notepad .folder', function(e) {
            $('.outer').removeClass('active');
            let notes = $('.note-preview');
            let id = $(this).data('id');
            $(notes).hide();
            for (let i = 0; i < notes.length; i++) {
                if ($(notes[i]).data('folder_id') == id) {
                    $(notes[i]).show();
                }
            }
            let select = $('#note_folder').find('option');
            for (let i = 0; i < select.length; i++) {
                if (id == $(select[i]).val()) {
                    $(select[i]).prop('selected', true);
                } else {
                    $(select[i]).prop('selected', false);
                }
            }
            $($(this).closest('.outer')[0]).addClass('active');
        });

        $('body').on('click', '#notepad #all_folders', function(e) {
            $('.outer').removeClass('active');
            $('#note_folder').find('option').prop('selected', false);
            $($(this).closest('.outer')[0]).addClass('active');
            $('#notepad .note-preview').show();
        });

        $('body').on('focusout', '#notepad #note-text-mobile', function(e) {
            $this.copyValueToText('#notepad #note-text-mobile', '#notepad #note-text');
            $('.mobile-content__view-desc #note-text').removeClass('d-none');
            $(this).addClass('d-none');
        });

        $('body').on('focusout', '#notepad #note-text-area', function(e) {
            $this.copyValueToText('#notepad #note-text-area', '#notepad #note-text');
            $('#note-text').removeClass('d-none');
            $(this).addClass('d-none');
        });

        $('body').on('focusout', '#notepad #note-text-title-input', function(e) {
            $this.copyValueToText('#notepad #note-text-title-input', '#notepad #note-text-title');
            $(this).addClass('d-none');
            $('#notepad #note-text-title').removeClass('d-none');
        });

        $('body').on('click', '#notepad .note-preview', function(e) {
            let click = this;
            let id = $(this).data('id');
            if ($(window).width() > 767) {
                $('#delete-note').show();
            }
            $.ajax({
                type: 'GET',
                url: '/notes/get-note',
                data: ({
                    id: id,
                }),
                success: function (response) {
                    $('.note-preview').removeClass('active');
                    $(click).addClass('active');
                    $('.save-text').addClass('d-none');
                    $('#note').html(response.note);
                    if ($('body').width() < 768) {
                        $('#note_container').toggleClass('d-none');
                        $('#note_container').addClass('d-block');
                        $('#select_note_container').removeClass('d-flex');
                        $('#select_note_container').addClass('d-none');
                    }
                    $this.copyTextToValue('#notepad #note-text', '#notepad #note-text-area');
                    $this.copyTextToValue('#notepad #note-text', '#notepad #note-text-mobile');
                    $('#documents_outer').html(response.documents);
                    $('#documents_desktop').html(response.documents);
                    $('#form-container').html(response?.share_modal);
                    $('#share-note').off('click').on('click', function () {
                        $('#share_workers').modal('show')
                    })
                    $('#share-note-modal').off('click').on('click', function () {
                        $('#share_workers').modal('show')
                    })
                    if($(window).width() > 767) {
                        let ta = $('#note-text-area');
                        window.autosizeTa = autosize(ta);
                        ta.trigger('autosize:update');
                    } else {
                        let mobileNote = $('#note-text-mobile');
                        window.autosizeTa = autosize(mobileNote);
                        mobileNote.trigger('autosize:update');
                    }
                    $this.viewBack();
                    const note = new Note(id);
                    note.scopeOpenDropZoneListener();
                    $this.shareNoteListener();
                    $this.loadTagify();
                    $this.editHandlers(response?.isEditAccess);
                },
            });
        });

        $('body').on('click', '#attach', function(e) {
            $('#modal_documents').modal('show');
        });
        $('body').on('click', '#delete_note', function(e) {
            if ($(window).width() > 767) {
                $('#delete-note').hide();
            } else {
                location.reload();
            }
            $.ajax({
                type: 'POST',
                url: '/notes/delete-note',
                data: ({
                    id: $('#note-text-id').val(),
                }),
                success: function (response) {
                    $('#note').html('');
                    $('#documents_outer').html('');
                    $('.save-text').addClass('d-none');
                    $this.updateNotes(response.notes);
                    $this.getFolders();
                    $('#count_all_folders').text(response.notes.length);
                    location.reload();
                },
            });
        });
        $('body').on('click', '.edit_folder', function(e) {
            let id = $(this).data('id');
            let name = $(this).data('folder_name');
            $('#folder_modal #folder_id').val(id);
            $('#folder_modal #folder_name').val(name);
            $('#folder_modal_title').text('Editing ');
            $('#folder_modal .add').addClass('d-none');
            $('#folder_modal .save').removeClass('d-none');
            $('#folder_modal').modal('show');
        });
        $('body').on('click', '#folder_modal #save_folder', function(e) {

            $.ajax({
                type: 'POST',
                url: '/notes/save-folder',
                data: ({
                    id: $('#folder_id').val(),
                    name: $('#folder_name').val()
                }),
                success: function (response) {
                    $this.getFolders();
                },
            });
        });
        $('body').on('click', '#folder_modal #delete_folder', function(e) {
            $.ajax({
                type: 'POST',
                url: '/notes/delete-folder',
                data: ({
                    id: $('#folder_id').val()
                }),
                success: function (response) {
                    $this.getFolders();
                    $this.updateNotes(response.notes);
                    $('#count_all_folders').text(response.notes.length);
                    location.reload();
                },
            });
        });

        $('body').on('click', '#notepad #switch', function(e) {
            $('.hided').toggleClass('mobile-content__display');
            $('.hided').toggleClass('d-none');
            $('#note-outer').css('border-left', '10px solid #FFF2DA');
            if($('#notepad #switch').hasClass('fa-chevron-right'))
            {
                $('#note-outer').css('border-left', '0px solid #FFF2DA');
            }
            $('#notepad #switch').toggleClass(['fa-chevron-left', 'fa-chevron-right']);
            $('#notepad #note-outer').toggleClass(['col-6', 'col-12']);
            $('.attach-files').toggleClass('d-none');
        });
    },

    editHandlers(isEditAccess, isReadAccess = true){
        let $this = this
        if (isEditAccess) {
            $('[data-target="#deleteNote"]').removeClass('d-none').addClass('d-flex')

            $('body').off('click', '#notepad .edit-text')
                .on('click', '#notepad .edit-text', function (e) {

                    $this.copyTextToValue('#notepad #note-text', '#notepad #note-text-area');
                    $('#note-text-area').removeClass('d-none');
                    $('#notepad #note-text').addClass('d-none');
                    $('#notepad .edit-text').addClass('d-none');
                    $('#notepad .save-text').removeClass('d-none');
                    $('#note-text-area').focus();

                    $this.copyTextToValue('#notepad #note-text', '#notepad #note-text-mobile');
                    $('#note-text-mobile').removeClass('d-none');
                    $('#note-text-mobile').focus();

                    autosize.update(window.autosizeTa);
                });

            $('body').off('click', '#notepad #note-text-title')
                .on('click', '#notepad #note-text-title', function (e) {
                    $this.copyTextToValue('#notepad #note-text-title', '#notepad #note-text-title-input');
                    $(this).addClass('d-none');
                    $('#notepad #note-text-title-input').removeClass('d-none');
                    $('#note-text-title-input').focus();
                });

            $('body').off('click', '#notepad .save-text')
                .on('click', '#notepad .save-text', function (e) {
                    $this.saveNote();
                });
        }else{
            $('[data-target="#deleteNote"]').addClass('d-none').removeClass('d-flex')
            $('#share-note').addClass('d-none')
            $('#share-note').off('click')
            $('#notepad .attach').addClass('d-none')
            $('body').off('click', '#notepad .edit-text')
            $('body').off('click', '#notepad #note-text-title')
            $('body').off('click', '#notepad .save-text')
            if(!isReadAccess){
                let id = $('#note-text-id').val()
                $('#note').html('')
                $(`.note-preview[data-id="${id}"]`).remove()
            }
        }
    },

    shareNoteListener(){
        let _this = this
        $('#share-to_workers').off().on('click', function () {
            let readers = $("textarea[name='readers']").val()
            let editors = $("textarea[name='editors']").val()
            readers = readers ? JSON.parse(readers).map(el=>el.value) : ''
            editors = editors ? JSON.parse(editors).map(el=>el.value) : ''
            $.ajax({
                type: 'post',
                url: 'notes/share-note',
                data: {
                    'note': $('#note-text-id').val(),
                    'readers': readers,
                    'editors': editors,
                    'all_readers': $("#all_readers").prop('checked') ? 1 : 0,
                    'all_editors': $("#all_editors").prop('checked') ? 1 : 0,
                },
                success: function (response) {
                    console.log(response)
                    _this.editHandlers(response?.isEditAccess, response?.isReadAccess)
                }
            })
        })
    },

    loadTagify() {
        const deleteShield = tagify =>{
            setTimeout(()=>{
                if(tagify.value.length < window.allWorkers.length)
                    $(`#all_${tagify.DOM.originalInput.name}`).prop('checked', false)
                else
                    $(`#all_${tagify.DOM.originalInput.name}`).prop('checked', true)
                $(`#all_${tagify.DOM.originalInput.name}`).trigger('change')
            },0)
        }
        let inputs = document.querySelectorAll('#share_workers .tagify-input');
        for(let input of inputs){
            let tagify = new Tagify(input, {
                enforceWhitelist: true,
                delimiters: null,
                keepInvalidTags: false,
                tagTextProp:'title',
                whitelist: window.allWorkers,
                dropdown: {
                    mapValueTo: 'title',
                    maxItems: 20,
                    position: "text",
                    enabled: 0
                },
                callbacks:{
                    add: ()=>deleteShield(tagify),
                    remove: ()=>deleteShield(tagify)
                }
            });
            $(`#all_${input.name}`).off('change').on('change',(ev)=>{
                tagify.setDisabled(ev.currentTarget.checked)
            })
        }
    },

    openmenu() {
        $('.open-sidebar').click(function (){
            $('.notepad .common-list').toggleClass('note-menu');
        });
    },


    getFolders() {
        let $this = this;
        $.ajax({
            type: 'GET',
            url: '/notes/get-folders',
            success: function (response) {
                $this.updatePageBlock('#folder_tmpl', '#notepad .folders #folders', response.folders);
                $this.updatePageBlock('#folder_select_tmpl', '#notepad #note_modal #note_folder', response.folders);
                $('#folder_modal').modal('hide');
            },
        });
    },
    updatePageBlock(tmpl_id, target_id, data) {
        let tmpl = $(tmpl_id).html();
        let html = '';
        for (let index = 0; index < data.length; index++) {
            let view = data[index];
            html += Mustache.render(tmpl, view);
        }
        $(target_id).html(html);
    },
    updateNotes(notes) {
        let $this = this;
        let note_id = $('.note-preview.active').data('id');
        let folder_id = $('.note-preview.active').data('folder_id');
        let is_all_folders = $('.outer.active #all_folders');
        for (let i = 0; i < notes.length; i++) {
            if (notes[i].id == note_id) {
                notes[i].active = true;
            }
            if (notes[i].folder_id != folder_id && is_all_folders.length == 0) {
                notes[i].folder = true;
            }
        }
        $this.updatePageBlock('#note_tmpl', '#notepad #notes', notes);
    },
    updateNote(id) {
        let notes = $('#notes').children();
        for (let i = 0; i < notes.length; i++) {
            if ($(notes[i]).data('id') == id) {
                $(notes[i]).find('.title').first().text($('#note-text-title-input').val());
                let text = $('#note-text').html().replace(/<br>/g,'\n')
                text = (text.length>100 ? text.substring(0,100)+'...' : text).replace(/\n/g,'<br>')
                $(notes[i]).find('.note-text').first().html(text);
            }
        }
    },
    updateMobileNote(id) {
        let notes = $('#mobile-notes').children();
        for (let i = 0; i < notes.length; i++) {
            if ($(notes[i]).data('id') == id) {
                $(notes[i]).find('.mobile-content__notes-wrapper-title').first().text($('#note-text-title-input').val());
            }
        }
    },

    saveNote() {
        let $this = this;
        let id = $('#note-text-id').val();

        let contentNote;
        if ($(window).width() > 767) {
            contentNote = $('#note-text-area').val();
        } else {
            contentNote = $('#note-text-mobile').val();
        }
        $.ajax({
            type: 'POST',
            url: '/notes/save-note',
            data: ({
                id: id,
                name: $('#note-text-title-input').val(),
                text: contentNote,
            }),
            success: function (response) {

                $('#save-alert').text('"' + $('#note-text-title-input').val() + '" was saved successfully');

                if($(window).width() > 767) {
                    $this.copyValueToText('#notepad #note-text-area', '#notepad #note-text');
                    $('#old-text').val($('#note-text-area').val());
                    $this.updateNote(id);
                    $this.updateMobileNote(id)
                } else {
                    $this.copyValueToText('#notepad #note-text-mobile', '#notepad #note-text');
                    $('#old-text').val($('#note-text-mobile').val());
                    $this.updateNote(id);
                    $this.updateMobileNote(id)
                }

                setTimeout(function() {
                    $('#save-alert').text('');
                }, 5000);
            }
        });
    },


    copyValueToText(value, text) {
        let new_text = this.decodeHtml($(value).val()).replace(/\n/g, '<br>');
        $(text).html(new_text);
    },
    copyTextToValue(text, value) {
        let new_text = this.encodeHtml($(text).html().replace(/<br>/g, '\n'));
        $(value).val(new_text);
    },
    decodeHtml(text){
        const map = {
            '&':'&amp;',
            '<':'&lt;',
            '>':'&gt;'
        }
        return text.replace(/[&<>]/g, m=>map[m])
    },
    encodeHtml(text){
        const map = {
            '&amp;':'&',
            '&lt;':'<',
            '&gt;':'>'
        }
        return text.replace(/(&amp;|&lt;|&gt;)/g, m=>map[m])
    },
    autoSave() {
        let $this = this;
        if ($('#notepad').length) {
            setInterval(function(){
                if ($(window).width() > 767) {
                    if ($('#note-text-id').val() && $('#note-text-id').val() != '' && ($('#note-text-area').val() != $('#old-text').val())) {
                        $this.saveNote();
                    }
                } else {
                    if ($('#note-text-id').val() && $('#note-text-id').val() != '' && ($('#note-text-mobile').val() != $('#old-text').val())) {
                        $this.saveNote();
                    }
                }
            }, 1000 * 10);
        }
    },

    viewOpen() {
        $('.mobile-content__open').click(function (e){
            $('.notepad-breadcrumbs-mobile').hide();
            $('.notes').addClass('without-title');
            $('.mobile-content__view').toggleClass('d-none');
            $('.mobile-content__wrapper').toggleClass('d-none');
            scroll(0,0); //костыль, возможно нужно переделать открытие в модалку с выводом всех данных
        });
    },
    viewBack() {
        $('.view_back').click(function (e){
            $('.notepad-breadcrumbs-mobile').show();
            $('.notes').removeClass('without-title');
            $('.mobile-content__view').addClass('d-none')
            $('.mobile-content__wrapper').toggleClass('d-none');

            if ($('body').width() < 768) {
                $('#select_note_container').removeClass('d-none');
                $('#select_note_container').addClass('d-flex');
                $('#note_container').removeClass('d-block');
                $('#note_container').addClass('d-none');
            }
            $('#note').html('');
            $('.note-preview.active').removeClass('active');
        });
    }

}
